export default __webpack_public_path__ + "static/media/article03.ba42f5af.md";